/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：关联业务表:将文件信息存入业务表或从业务表删除
 * 更新记录: 
 */
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefFileObjectService {

  /**
   * 文件附件表服务的请求路径
   * @ignore 
   */
  domain = environment.fileWebAPI + "refFileObject";

  constructor(
    private http: SwHttpClientService,  //封装的http请求服务
  ) { }

  /**
   * 将文件保存到附件关联表中的方法
   * @param objectId 业务ID
   * @param code 策略
   * @param files Map<string,string>数组,内存文件id与排序等字段，目前为文件id：fileId，排序：sort,文件业务关联表主键:fileObjectId
   * @param fileObjectId 文件业务关联ID
   */
  save(objectId: string, code: string, files: any) {
    let param = { objectId: objectId, code: code, files: files };
    console.log("上传文件参数")
    console.log(param)
    return this.http.Post(`${this.domain}/addBatch`, param);
  }

  savePro(objectId: string, code: string, files: any): Promise<void> {
    return new Promise((resolve) => {
      let param = { objectId: objectId, code: code, files: files };
      this.http.Post(`${this.domain}/addBatch`, param)
        .subscribe((res) => {
          resolve(res);
        });
    });
  }

  /**
  * 将图片组生成为pdf文件的方法
  */
  imgsToPdf(param) {
    return this.http.Post(`${environment.fileWebAPI}physicalFile/imgsToPdf`, param);
  }

  /**
   * 将文件从附件关联表中删除的方法
   * @param fileIds 文件的id组成的数组
   */
  delete(fileIds: string[]) {
    let param = { delIds: fileIds };
    return this.http.Post(`${this.domain}/deleteBatch`, param);
  }

  deletePro(fileIds: string[]): Promise<void> {
    return new Promise((resolve) => {
      let param = { delIds: fileIds };
      this.http.Post(`${this.domain}/deleteBatch`, param)
        .subscribe((res) => {
          resolve(res);
        });
    });
  }

  /**
   * 将文件从附件关联表中删除的方法
   * @param param 
   */
  queryPageList(param) {
    return this.http.Post(`${this.domain}/queryPageList`, param);
  }
}
